module.exports = __webpack_public_path__ + "static/img/brother_green.5aa22d78.png";